import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  const authToken = localStorage.getItem('authToken');

  if (!isAuthenticated || !authToken) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;

